export class CreateUpdateLookupModel {
  name: string;
}
